import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { getCabLandingPage, listCabPopularRoutes, listCabVehicles } from "../../legacy/api/cabsPublic";
import { asArray } from "../mobileUtils";
import { cabTypes } from "../data/mobileFallbackData";
import MobileLayout from "../layouts/MobileLayout";

export default function MobileCabs() {
  const navigate = useNavigate();
  const [vehicles, setVehicles] = useState(cabTypes);
  const [routes, setRoutes] = useState(["Delhi to Jaipur", "Delhi to Rishikesh", "Mumbai to Lonavala"]);
  const [form, setForm] = useState(() => {
    const date = new Date();
    date.setDate(date.getDate() + 1);
    return { pickup: "", drop: "", date: date.toISOString().slice(0, 10), time: "10:00" };
  });
  const update = (key, value) => setForm((current) => ({ ...current, [key]: value }));
  const submit = (event) => {
    event.preventDefault();
    const query = new URLSearchParams(form);
    navigate(`/cabs/list?${query}`);
  };

  useEffect(() => {
    let active = true;
    Promise.allSettled([getCabLandingPage(), listCabVehicles({ limit: 6 }), listCabPopularRoutes()]).then((results) => {
      if (!active) return;
      const vehicleRows = asArray(results[1]?.value);
      if (vehicleRows.length) {
        setVehicles(vehicleRows.map((item) => ({
          title: item.name || item.title || "Premium cab",
          meta: item.category_name || (item.seats ? `${item.seats} seats` : "Comfort travel"),
        })));
      }
      const routeRows = asArray(results[2]?.value);
      if (routeRows.length) {
        setRoutes(routeRows.slice(0, 6).map((item) => item.title || item.name || item.route_name || "Popular route"));
      }
    });
    return () => {
      active = false;
    };
  }, []);

  return (
    <MobileLayout>
      <section className="hv-section" style={{ marginTop: 0 }}>
        <h1 className="hv-section-title" style={{ fontSize: 32 }}>Book premium cabs</h1>
        <p className="hv-muted-row" style={{ marginTop: 8 }}>Airport transfers, city rides and outstation routes with Homevilas support.</p>
      </section>
      <form className="hv-search-card hv-cab-form" onSubmit={submit}>
        <div className="hv-field hv-field-icon"><label>Pickup</label><i className="bi bi-geo-alt" /><input value={form.pickup} onChange={(event) => update("pickup", event.target.value)} placeholder="Pickup location" required /></div>
        <div className="hv-field hv-field-icon"><label>Drop</label><i className="bi bi-geo" /><input value={form.drop} onChange={(event) => update("drop", event.target.value)} placeholder="Drop location" required /></div>
        <div className="hv-mini-grid" style={{ gridTemplateColumns: "repeat(2, minmax(0, 1fr))" }}>
          <div className="hv-field hv-field-icon"><label>Date</label><i className="bi bi-calendar3" /><input type="date" value={form.date} onChange={(event) => update("date", event.target.value)} /></div>
          <div className="hv-field hv-field-icon"><label>Time</label><i className="bi bi-clock" /><input type="time" value={form.time} onChange={(event) => update("time", event.target.value)} /></div>
        </div>
        <button className="hv-primary-btn" type="submit">Book Cab</button>
      </form>
      <section className="hv-section">
        <div className="hv-section-head"><h2 className="hv-section-title">Cab types</h2></div>
        <div className="hv-list-stack">
          {vehicles.map((item) => (
            <div className="hv-card hv-cab-type" key={item.title}>
              <span className="hv-cab-icon"><i className="bi bi-car-front" /></span>
              <div><strong>{item.title}</strong><div className="hv-muted-row">{item.meta}</div></div>
              <i className="bi bi-chevron-right" aria-hidden="true" />
            </div>
          ))}
        </div>
      </section>
      <section className="hv-section">
        <div className="hv-section-head"><h2 className="hv-section-title">Popular routes</h2></div>
        <div className="hv-list-stack">
          {routes.map((route) => <Link className="hv-card" style={{ padding: 14, color: "inherit", textDecoration: "none", fontWeight: 800 }} to="/cabs/list" key={route}>{route}</Link>)}
        </div>
      </section>
    </MobileLayout>
  );
}
